import React from 'react';
//import { connect } from 'react-redux';
import randomstring from 'uuid/v4';
//import PropTypes from 'prop-types';

import Field from './Field';
import Switch from './types/StyleSwitch';

import Grid from '@material-ui/core/Grid';

class Group extends React.Component {
    state = {
        desactivado: false,
        obligatorio: false,
    };

    static getDerivedStateFromProps(props, state) {

        const { data, parentDeactivated } = props;

        if (data !== state.data || parentDeactivated !== state.parentDeactivated) {
            state.desactivado = data.desactivado;
            state.parentDeactivated = parentDeactivated;
            state.data = data;
            state.data.obligatorio = false;
            return state;
        }
        return null;
    }

    handleDeactive = (data, checked) => {
        this.props.setValue(data.codigo, undefined, '', checked, {});
        this.setState({ desactivado: checked });
    };

    render() {
        const { hide, editable } = this.props;
        const { desactivado, data, parentDeactivated } = this.state;

        if (data && data.hijos && data.hijos.length > 0) {
            return (
                <div key={randomstring()} className={'flex_full_column padding_bottom_9'}>
                    <Grid container alignItems="flex-start" justify="flex-end" direction="row">
                        <Grid item xs={12}>
                            <div className="align_center flex_full_row">
                                <div className="center column_icon">
                                    <Switch
                                        data={data}
                                        disabled={
                                            !editable ||
                                            data.sololectura ||
                                            !data.desactivable ||
                                            parentDeactivated
                                        }
                                        desactivado={desactivado}
                                        value={undefined}
                                        onChange={this.handleDeactive}
                                    />
                                </div>
                                <div
                                    className="barlow_regular_textwrap text_align_left text_wrap upper padding_left_12 flex_full_row bg_cloudy_blue c_purple"
                                    dangerouslySetInnerHTML={{ __html: data.nombre.toLowerCase() }}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div className="flex_full padding_left_24">
                                {data.hijos &&
                                    data.hijos.map((info, i) => {
                                        if (info.hijos && info.hijos.length > 0) {
                                            return (
                                                <Group
                                                    {...this.props}
                                                    data={info}
                                                    last={data.hijos.length === i + 1}
                                                    hide={hide}
                                                    editable={editable}
                                                    parentDeactivated={
                                                        parentDeactivated || desactivado
                                                    }
                                                />
                                            );
                                        } else {
                                            return (
                                                <Field
                                                    key={info.codigo}
                                                    data={info}
                                                    hide={hide}
                                                    editable={editable}
                                                    last={data.hijos.length === i + 1}
                                                    parentDeactivated={
                                                        parentDeactivated || desactivado
                                                    }
                                                />
                                            );
                                        }
                                    })}
                            </div>
                        </Grid>
                    </Grid>
                </div>
            );
        } else {
            return null;
        }
    }
}

export default Group;



// WEBPACK FOOTER //
// ./src/components/complex/forms/Group.js